import styled from "@emotion/styled";
import { IStyledComponentProps } from "../../theme/theme.types";

const PackageListItem = styled.div<IStyledComponentProps>`
  &.package-list-item {
    background-color: ${({ theme }) => theme.colors.essential.white};
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.2);
    padding: 12px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.grays.tertiary};
    border-left: 4px solid transparent;

    .package-icon {
      font-size: 16px;
    }

    .up-caret {
      margin-bottom: -3px;
    }
    .down-caret {
      margin-top: -3px;
    }

    .chevron-style {
      width: 16px;
      height: 16px;
      color: #cecece;
    }

    .package-list-item-label {
      font-family: ${({ theme }) => theme.fontFamilies.semiBold};
    }
    .package-list-item-sublabel {
      font-size: ${({ theme }) => theme.fontSizes.smallest}px;
    }

    .badge {
      border-radius: 0;
      width: 72px;
      font-size: 11px;
      padding: 6px 0;
    }

    &.selected,
    &:hover:not(.disabled-package) {
      cursor: pointer;
      border-left: 4px solid ${({ theme }) => theme.colors.grays.tertiary};
    }

    &.disabled-package {
      background-color: ${({ theme }) => theme.colors.essential.grayLight};
    }
  }
`;

export default { PackageListItem };
